
            jQuery(document).ready(function() {

                $('.bloc_menu.upright li.upright a').empty();

                $('.bloc_menu li.index a').empty();

            });
